$breakpoint: 768px;

// ─── Header ───────────────────────────────────────────────
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 68px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  box-shadow: 0px 4px 12px 0px rgba(18, 18, 18, 0.1);
  z-index: 1000;
  box-sizing: border-box;
}

.headerLogo {
  height: 36px;
  width: 108px;
  flex-shrink: 0;
}

.headerActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}

.langDropdownContainer {
  position: relative;
}

.langSelect {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: "Source Sans 3 Regular", sans-serif;
  font-size: 16px;
  line-height: 1.4;
  color: #333333;
  cursor: pointer;
  user-select: none;
  background: none;
  border: none;
  padding: 1px 0;
}

.chevron {
  width: 24px;
  height: 24px;
  transition: transform 0.2s;
}

.chevronOpen {
  transform: rotate(180deg);
}

.dropdownMenu {
  position: absolute;
  top: calc(100% + 12px);
  right: -10px;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  min-width: 140px;
  overflow: hidden;
  z-index: 1001;
}

.dropdownItem {
  background: none;
  border: none;
  text-align: left;
  padding: 12px 16px;
  font-size: 16px;
  font-family: "Source Sans 3 Regular", sans-serif;
  color: #333333;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
}

.dropdownItemActive {
  background-color: #e6f0ff;
  color: #0033a0;
  font-weight: 600;

  &:hover {
    background-color: #dcedff;
  }
}

// ─── Body ─────────────────────────────────────────────────
.landingPage {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #edecee;
  padding-top: 68px;
  box-sizing: border-box;
}

.mainContent {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 40px;
}

.contentWrapper {
  width: 100%;
  max-width: 638px;
  padding: 0 24px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;

  @media (max-width: $breakpoint) {
    padding: 0 16px;
    margin-top: 16px;
  }
}

.heroSection {
  margin-bottom: 16px;
}

.heroImage {
  width: 100%;
  display: block;
  object-fit: cover;
}

.heroTitle {
  font-family: "Montserrat SemiBold", sans-serif;
  font-size: 32px;
  font-weight: 600;
  line-height: 1.3;
  color: #1a1a23;
  margin: 0 0 4px;
}

.heroSubtitle {
  font-family: "Montserrat Medium", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: #636369;
  margin: 0;
}

// ─── Publication Cards ────────────────────────────────────
.pubGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
}

.pubCard {
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #d8d8da;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-decoration: none;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.pubLogo {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.pubName {
  font-family: "Montserrat SemiBold", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: #1a1a23;
  text-align: center;
}

@media (max-width: $breakpoint) {
  .pubGrid {
    gap: 16px;
  }

  .pubCard {
    padding: 16px;
  }

  .pubLogo {
    width: 48px;
    height: 48px;
  }

  .pubName {
    display: none;
  }
}

// ─── Divider ──────────────────────────────────────────────
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 16px 0 24px;

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #d8d8da;
  }
}

.dividerText {
  padding: 0 16px;
  font-family: "Montserrat Medium", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #1a1a23;
  white-space: nowrap;
}

// ─── Single Copy Section ──────────────────────────────────
.singleCopyTitle {
  font-family: "Montserrat SemiBold", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3;
  color: #1a1a23;
  margin: 0 0 4px;
}

.singleCopySubtitle {
  font-family: "Montserrat Medium", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: #636369;
  margin: 0 0 24px;
}

.buyButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border-radius: 9999px;
  border: 1px solid #3442a0;
  color: #3442a0;
  background-color: #ffffff;
  text-decoration: none;
  font-family: "Montserrat Medium", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.25;
  min-height: 44px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 24px;
  box-sizing: border-box;

  &:hover {
    background-color: rgba(52, 66, 160, 0.05);
  }
}

// ─── Footer ───────────────────────────────────────────────
.footer {
  width: 100%;
  background-color: #333333;
  color: #f5f5f5;
  padding: 32px 48px;
  box-sizing: border-box;
  font-family: "Source Sans 3 Regular", sans-serif;

  @media (max-width: $breakpoint) {
    padding: 32px 16px;
  }
}

.footerContent {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: $breakpoint) {
    flex-direction: column;
    position: relative;
  }
}

.footerColumns {
  display: flex;
  gap: 60px;

  @media (max-width: $breakpoint) {
    flex-direction: column;
    gap: 48px;
    width: 100%;
  }
}

.footerColumn {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.footerHeading {
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  margin: 0 0 8px;
  color: #f5f5f5;
}

.footerList {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 0;
  }

  a {
    color: #f5f5f5;
    text-decoration: none;
    font-size: 18px;
    line-height: 1.4;

    &:hover {
      text-decoration: underline;
    }
  }
}

.footerContactItem {
  font-size: 18px;
  line-height: 1.4;
  color: #f5f5f5;
  margin-bottom: 0;
}

.footerContactBlock {
  margin-bottom: 16px;
}

.footerLink {
  color: #008bff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.footerFeedbackLink {
  color: #5663d9;
  text-decoration: underline;
  text-decoration-style: dotted;
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 8px;
  display: inline-block;
}

.footerLogo {
  height: 46px;
  width: 137px;
  filter: brightness(0) invert(1);
  flex-shrink: 0;

  @media (max-width: $breakpoint) {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.footerBottom {
  font-size: 14px;
  line-height: 1.4;
  color: #f5f5f5;
  margin-top: 29px;

  p {
    margin: 0;
  }
}
